import { RootState } from '../store';
import { CurrentPageState } from '../reducers/ui/currentPage.ui';
import { UsersUIState } from '../reducers/ui/users.ui';
import {
  AccountUIState,
  ActionPlanningUIState,
  AdminUIState,
  AnalyzeUIState,
  BenchmarkUIState,
  CategoriesUIState,
  ConversationsUIState,
  EmployeesUIState,
  HeatmapUIState,
  LearningContentUIState,
  ReportingUIState,
  ResponseRateUIState,
  RolesUIState,
  SettingsUIState,
  SurveyBuildUIState,
  SurveyListUIState,
  SurveysUIState,
  SurveyTypesUIState,
} from '../types/ui.types';

const selectAccountUI =
  () =>
  (state: RootState): AccountUIState =>
    state.ui.account;

const selectActionPlanningUI =
  () =>
  (state: RootState): ActionPlanningUIState =>
    state.ui.actionPlanning;

const selectAdminUI =
  () =>
  (state: RootState): AdminUIState =>
    state.ui.admin;

const selectAnalyzeUI =
  () =>
  (state: RootState): AnalyzeUIState =>
    state.ui.analyze;

const selectCategoriesUI =
  () =>
  (state: RootState): CategoriesUIState =>
    state.ui.categories;

const selectConversationsUI =
  () =>
  (state: RootState): ConversationsUIState =>
    state.ui.conversations;

const selectEmployeesUI =
  () =>
  (state: RootState): EmployeesUIState =>
    state.ui.employees;

const selectHeatmapUI =
  () =>
  (state: RootState): HeatmapUIState =>
    state.ui.heatmap;

const selectLearningContentUI =
  () =>
  (state: RootState): LearningContentUIState =>
    state.ui.learningContent;

const selectReportingUI =
  () =>
  (state: RootState): ReportingUIState =>
    state.ui.reporting;

const selectResponseRateUI =
  () =>
  (state: RootState): ResponseRateUIState =>
    state.ui.responseRate;

const selectRolesUI =
  () =>
  (state: RootState): RolesUIState =>
    state.ui.roles;

const selectSettingsUI =
  () =>
  (state: RootState): SettingsUIState =>
    state.ui.settings;

const selectSurveyListUI =
  () =>
  (state: RootState): SurveyListUIState =>
    state.ui.surveyList;

const selectSurveysUI =
  () =>
  (state: RootState): SurveysUIState =>
    state.ui.surveys;

const selectSurveyTypesUI =
  () =>
  (state: RootState): SurveyTypesUIState =>
    state.ui.surveyTypes;

const selectUsersUI =
  () =>
  (state: RootState): UsersUIState =>
    state.ui.users;

const selectBenchmarkUI =
  () =>
  (state: RootState): BenchmarkUIState =>
    state.ui.benchmark;

const selectSurveyBuildUI =
  () =>
  (state: RootState): SurveyBuildUIState =>
    state.ui.surveyBuild;

const selectCurrentPageUI =
  () =>
  (state: RootState): CurrentPageState =>
    state.ui.currentPage;

export const uiSelectors = {
  selectAccountUI,
  selectActionPlanningUI,
  selectAdminUI,
  selectAnalyzeUI,
  selectCategoriesUI,
  selectConversationsUI,
  selectEmployeesUI,
  selectHeatmapUI,
  selectLearningContentUI,
  selectReportingUI,
  selectResponseRateUI,
  selectRolesUI,
  selectSettingsUI,
  selectSurveyListUI,
  selectSurveysUI,
  selectSurveyTypesUI,
  selectUsersUI,
  selectBenchmarkUI,
  selectSurveyBuildUI,
  selectCurrentPageUI,
};
